import { render, staticRenderFns } from "./sync-scroll-bars.vue?vue&type=template&id=65d0aa78&"
import script from "./sync-scroll-bars.vue?vue&type=script&lang=js&"
export * from "./sync-scroll-bars.vue?vue&type=script&lang=js&"
import style0 from "./sync-scroll-bars.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65d0aa78')) {
      api.createRecord('65d0aa78', component.options)
    } else {
      api.reload('65d0aa78', component.options)
    }
    module.hot.accept("./sync-scroll-bars.vue?vue&type=template&id=65d0aa78&", function () {
      api.rerender('65d0aa78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SyncScrollBars/sync-scroll-bars.vue"
export default component.exports